<div class="relative">
  <tui-loader [overlay]="true" [showLoader]="isLoading">
    <div class="container">
      <div class="flex gap-3 border-b border-b-[#bb0021] pb-2">
        <button style="cursor: pointer" class="p-2" (click)="cancel()">
          <tui-svg
            src="tuiIconArrowLeftCircleLarge"
            style="color: black"
            class="hover:scale-110 transition-all duration-100"
          ></tui-svg>
        </button>
        <p
          class="flex items-center text-black text-[1.5rem] font-bold"
          *ngIf="status !== 'edit'"
        >
          Add Payment
        </p>
        <p
          class="flex items-center text-black text-[1.5rem] font-bold"
          *ngIf="status === 'edit'"
        >
          Edit Payment
        </p>
      </div>
      <div
        class="flex items-center justify-center xl:justify-normal mt-5 2xl:my-10 lg:ml-10"
      >
        <div class="w-full sm:w-[400px]">
          <form [formGroup]="paymentForm">
            <div class="">
              <div class="mt-4">
                <label class="text-black">Payment Type</label>
                <tui-select
                  formControlName="paymentMethod"
                  [tuiTextfieldCleaner]="true"
                >
                  <tui-data-list-wrapper
                    *tuiDataList
                    [items]="paymentMethodOptions"
                  ></tui-data-list-wrapper>
                  Payment Type (Online/Cash)
                </tui-select>
              </div>

              <div class="mt-4">
                <label class="text-black">Select Member</label>
                <tui-combo-box
                  tuiTextfieldSize="m"
                  [stringify]="stringify"
                  formControlName="memberSelected"
                >
                  Member
                  <input placeholder="Choose your hero" tuiTextfield />
                  <tui-data-list-wrapper
                    *tuiDataList
                    [itemContent]="stringify | tuiStringifyContent"
                    [items]="members | tuiFilterByInputWith : stringify"
                  ></tui-data-list-wrapper>
                </tui-combo-box>
                <tui-error
                  formControlName="memberSelected"
                  [error]="[] | tuiFieldError | async"
                ></tui-error>
              </div>

              <div class="mt-4">
                <label class="text-black">Enter Amount (LKR)</label>
                <tui-input
                  tuiTextfieldSize="l"
                  [tuiTextfieldCleaner]="true"
                  [tuiTextfieldLabelOutside]="true"
                  [style.text-align]="'left'"
                  class="tui-space_top-1"
                  formControlName="amount"
                >
                  Amount
                  <input autocomplete="amount" tuiTextfield type="text" />
                </tui-input>
                <tui-error
                  formControlName="amount"
                  [error]="[] | tuiFieldError | async"
                ></tui-error>
              </div>

              <div class="mt-4">
                <label class="text-black">Enter Payment Date</label>
                <tui-input-date
                  [max]="currentDate"
                  tuiTextfieldSize="l"
                  [tuiTextfieldCleaner]="true"
                  [tuiTextfieldLabelOutside]="true"
                  [style.text-align]="'left'"
                  class="tui-space_top-1"
                  formControlName="date"
                >
                  Choose a date
                  <input autocomplete="dob" tuiTextfield type="text" />
                </tui-input-date>
                <tui-error
                  formControlName="date"
                  [error]="[] | tuiFieldError | async"
                ></tui-error>
              </div>

              <div class="mt-4">
                <label class="text-black">Select Payment Preset</label>
                <tui-select
                  formControlName="paymentPreset"
                  [tuiTextfieldCleaner]="true"
                >
                  <tui-data-list-wrapper
                    *tuiDataList
                    [items]="paymentPresets"
                  ></tui-data-list-wrapper>
                  Payment Preset
                </tui-select>
              </div>

              <div class="mt-4">
                <label class="text-black">Valid From</label>
                <tui-input-date
                  tuiTextfieldSize="l"
                  [tuiTextfieldCleaner]="true"
                  [tuiTextfieldLabelOutside]="true"
                  [style.text-align]="'left'"
                  class="tui-space_top-1"
                  formControlName="validFrom"
                >
                  Choose a date
                  <input autocomplete="validFrom" tuiTextfield type="text" />
                </tui-input-date>
                <tui-error
                  formControlName="validFrom"
                  [error]="[] | tuiFieldError | async"
                ></tui-error>
              </div>

              <div class="mt-4">
                <label class="text-black">Valid To</label>
                <tui-input-date
                  tuiTextfieldSize="l"
                  [tuiTextfieldCleaner]="true"
                  [tuiTextfieldLabelOutside]="true"
                  [style.text-align]="'left'"
                  class="tui-space_top-1"
                  formControlName="validTo"
                  [disabled]="true"
                >
                  Choose a date
                  <input
                    autocomplete="validTo"
                    tuiTextfield
                    type="text"
                    readonly
                  />
                </tui-input-date>

                <tui-error
                  formControlName="validTo"
                  [error]="[] | tuiFieldError | async"
                ></tui-error>
                <p class="ml-1.5 mt-1 text-black">{{ dateDiff }}</p>
              </div>
            </div>

            <div class="mt-4">
              <label class="text-black">Notes</label>
              <tui-input
                tuiTextfieldSize="l"
                [tuiTextfieldCleaner]="true"
                [tuiTextfieldLabelOutside]="true"
                [style.text-align]="'left'"
                class="tui-space_top-1"
                formControlName="notes"
              >
                Notes
                <input autocomplete="off" tuiTextfield type="text" />
              </tui-input>
            </div>

            <div class="flex gap-3 mt-7">
              <div class="w-full h-full">
                <button
                  (click)="cancel()"
                  tuiButton
                  appearance="secondary"
                  type="button"
                  class="w-full h-full text-[#bb0021] hover:bg-[#faf0f2] hover:text-[#bb0021]"
                >
                  Cancel
                </button>
              </div>
              <div class="w-full">
                <button
                  tuiButton
                  type="button"
                  class="w-full"
                  *ngIf="status !== 'edit'"
                  (click)="submit()"
                  [showLoader]="isLoading"
                >
                  <span class="text-white">Add Payment</span>
                </button>
                <button
                  tuiButton
                  type="button"
                  class="w-full"
                  *ngIf="status === 'edit'"
                  (click)="onUpdate()"
                  [showLoader]="isLoading"
                >
                  <span class="text-white">Update Payment</span>
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </tui-loader>
</div>
